<template>
    <v-container grid-list-sm text-xs-left>
        <v-layout column>
            <v-flex xs12>
                <v-card class="rounded">
                    <v-card-title class="pb-2">
                        <v-layout row wrap align-center>
                            <v-flex grow>
                                <span class="headline text-xs-left">Chat History</span>
                            </v-flex>
                            <!--<v-flex shrink>
                                <v-btn round dark color="primary" @click="initializeHistoryCallback">
                                    Refresh
                                    <v-icon right dark>
                                        mdi-restart
                                    </v-icon>
                                </v-btn>
                            </v-flex>-->
                        </v-layout>
                    </v-card-title>
                    <v-card-text class="pt-1">
                        <v-flex xs12 pb-4 pl-1 pr-2>
                            <v-text-field
                                    v-model="search"
                                    :append-icon="search?'close':'search'"
                                    :append-icon-cb="() => (search = '')"
                                    label="Search"
                                    single-line
                                    hide-details
                                    @keydown.native.escape="search=''">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-data-table
                                    :headers="headers"
                                    :items="history"
                                    :search="search"
                                    :rows-per-page-items='[5, 10, 25, 50, 100]'
                                    :pagination.sync="pagination"
                                    class="elevation-0"
                            >
                                <template
                                        slot="items"
                                        scope="props"
                                >
                                    <td class="text-xs-center">
                                    {{ props.item.user }}
                                </td>
                                    <td class="text-xs-center">
                                        {{ props.item.question }}
                                    </td>
                                    <td class="text-xs-center">
                                        {{ props.item.answer }}
                                    </td>
                                    <td class="text-xs-center">
                                        {{ props.item.date.toLocaleString() }}
                                    </td>
                                </template>
                            </v-data-table>
                            <!--<div class="text-xs-center pt-2">
                                <v-pagination
                                        v-model="pagination.page"
                                        :total-visible="5"
                                        :length="pages"
                                        prev-icon="mdi-menu-left"
                                        next-icon="mdi-menu-right"
                                />
                            </div>-->
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";

    export default {
        name: "HistoryChat",
        components: {},
        data() {
            return {
                search: "",
                pagination: {'sortBy': 'date', 'descending': true,},
                selected: [],
                headers: [
                    {text: "User", align: "center", value: "user",},
                    {text: "Question", align: "center", value: "question",},
                    {text: "Answer", align: "center", value: "answer",},
                    {text: "Date", align: "center", value: "date",},
                ],
                history: [],
            };
        },
        computed: {
            pages() {
                return this.pagination.rowsPerPage ? Math.ceil(this.history.length / this.pagination.rowsPerPage) : 0;
            },

        },
        created() {
            this.historyChat();
        },
        methods: {
            historyChat() {
                this.startups = [];
                let requestUrl = {
                    url: UrlsService.chatHistory,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get history chat",
                    loading: "Loading",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.history = [];
                        let history = response.response.additionalElement.history;
                        const regex = /http(.*?) /g;
                        for (let i = 0; i < history.length; i++) {
                            this.history.push({
                                user: history[i].user,
                                question: history[i].question,
                                answer: history[i].answer.replace(regex, ""),
                                date: new Date(history[i].date),
                            });
                        }
                    });
            },
        },

    };
</script>

<style lang="scss">
    .tr {
        height: 100px;
    }

</style>
